import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
    const location = useLocation();
    const isLanding = location.pathname === '/';

    return (
        <nav className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-4 border-b border-white/5 bg-black/50 backdrop-blur-xl supports-[backdrop-filter]:bg-black/20">
            <div className="flex items-center gap-2">
                <Link to="/" className="group flex items-center gap-2">
                    <div className="w-8 h-8 rounded-lg bg-white flex items-center justify-center text-black font-bold text-lg group-hover:scale-105 transition-transform">
                        L
                    </div>
                    <span className="text-xl font-bold tracking-tight text-white">
                        LOOK<span className="text-gray-500">REACT</span>
                    </span>
                </Link>
            </div>

            <div className="flex items-center gap-8">
                <Link
                    to="/"
                    className={`text-sm font-medium transition-colors hover:text-white ${isLanding ? 'text-white' : 'text-gray-400'}`}
                >
                    Home
                </Link>
                <Link
                    to="/components"
                    className={`text-sm font-medium transition-colors hover:text-white ${!isLanding ? 'text-white' : 'text-gray-400'}`}
                >
                    Components
                </Link>
                <a
                    href="https://github.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-medium text-gray-400 hover:text-white transition-colors flex items-center gap-2"
                >
                    GitHub
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                    </svg>
                </a>
            </div>
        </nav>
    );
};

export default Navbar;
